export enum ReactionTypeEnum {
  USER_REACTION = 'USER_REACTION',
  PROJECT_REACTION = 'PROJECT_REACTION',
  EVENT_REACTION = 'EVENT_REACTION',
  POST_REACTION = 'POST_REACTION',
  MEDIA_REACTION = 'MEDIA_REACTION',
  MESSAGE_REACTION = 'MESSAGE_REACTION',
  COMMENT_REACTION = 'COMMENT_REACTION',
}
